(function () {
    $(document).ready(function() {
        $('div.component.b05-button').each(function () {
            var attribute = $(this).find('div').attr('aria-label') ? $(this).find('div').attr('aria-label') : "";
            $(this).find('a').attr('role', "button");
            $(this).find('a').attr('tabindex', "0");
            $(this).find('a').attr('aria-label', attribute);
        });

        $('div.component.b05-button').on('keydown', function (e) {
            if ((e.keyCode === 13 || e.keyCode === 32)) {
                if ($(this).find("a").length)
                    $(this).find("a")[0].click();
            }
        });
        
        $('.b05-button.custom-color').each(function () {
            var bgColor = $(this).attr('data-backgroundcolor');
            if (bgColor) {
                $(this).css('background-color', bgColor);
            }
            var textColor = $(this).attr('data-textcolor');
            if (textColor) {
                $(this).css('color', textColor);
            }
            var borderColor = $(this).attr('data-bordercolor');
            if (borderColor) {
                $(this).css('border-color', borderColor);
            }
            $(this).css("border-radius", "12px");
            $(this).css("border-style", "solid");
            $(this).find('a').attr('style', 'padding: 10px 20px !important');
        });
    });
}(window.jQuery));


//adding new B05 button variant with external icon -FLWEP2 9930 - brought from custom-component.js

(function ($) {
    $(document).ready(function () {
        $('.custom_external_b05').each(function () {
            var bgColor = $(this).attr('data-backgroundcolor');
            if (bgColor) {
                $(this).css('background-color', bgColor);
            }
            var textColor = $(this).attr('data-textcolor');
            if (textColor) {
                $(this).css('color', textColor);
            }
            var borderColor = $(this).attr('data-bordercolor');
            if (borderColor) {
                $(this).css('border-color', borderColor);
            }

            $(this).css("border-style", "solid");
        });
    });
    $(document).ready(function () {
        $('.b05-button.custom-color').each(function () {
            var bgColor = $(this).attr('data-backgroundcolor');
            if (bgColor) {
                $(this).css('background-color', bgColor);
            }
            var textColor = $(this).attr('data-textcolor');
            if (textColor) {
                $(this).css('color', textColor);
            }
            var borderColor = $(this).attr('data-bordercolor');
            if (borderColor) {
                $(this).css('border-color', borderColor);
            }
            $(this).css("border-radius", "12px");
            $(this).css("border-style", "solid");
            $(this).find('a').attr('style', 'padding: 10px 20px !important');
        });
    });
}(window.jQuery));


/*Analytics for B05 Button*/
analytics.eventConfig.push(
    {
    "target": ".component.b05-button:not([data-bs-toggle*=modal])", 
    "codeId": "b05",
    "events": [
        {
            "eventTarget": "a[href*=\\http]",
            "eventType": "click",
            "tags": {
                "componentId": "b05",
                "componentName": "button",
                "destinationUrl": "",
                "elementText": "",
                "elementType": "generic button",
                "event": [
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "outbound"
                    }
                ],
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1",
                        "value": "pds download click"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                        "value": "sds download click"
                    },
                    {
                        "rule": "true",
                        "value": "outbound click"
                    }
                ],
                "fileName": "",
                "parentListSource": "",
                "parentName": "",
                "parentOrdinal": "",
                "parentTitle": ""
            }
        },
        {
            "eventTarget": "a:not([href*=\\http], [data-bs-toggle*=modal])",
            "eventType": "click",
            "tags": {
                "componentId": "b05",
                "componentName": "button",
                "destinationUrl": "",
                "elementText": "",
                "elementType": "generic button",
                "event": [
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().startsWith('mailto:') || $(context).attr('href').toLowerCase().startsWith('tel'))",
                        "value": "contact"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "click to email"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('tel')",
                        "value": "click to call"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "other media asset click"
                    },
                    {
                        "rule": "true",
                        "value": "button internal navigation click"
                    }
                ],
                "fileName": "",
                "parentListSource": "",
                "parentName": "",
                "parentOrdinal": "",
                "parentTitle": ""
            }
        }
    ]
},
{
    "target": ".library-detail-component", 
    "codeId": "b05",
    "events": [
        {
            "eventTarget": "a.btn-primary:not(.b05-button):not([href*=\\http])",
            "eventType": "click",
            "tags": {
                "componentId": "b05",
                "componentName": "button",
                'event1': '',
                'eventCategory': 'Customer Enablement & Education',
                'eventAction': '',
                'eventLabel': "",
                "environment": "",
                'document_title': "",
                'document_type': "",
                'page_type': "",
                'page_title': "",
                'page_bu': "",
                'page_language': "",
                'sitecore_contact_id': "",
                'pardot_cookie_id': ""
            }
        }
    ]
}
);